import React from 'react';
import './AutoSuggestionPopup.css';

const AutoSuggestionPopup = ({ item, onAccept, onReject }) => {
    return (
        <div className="ace-suggestion-popup">
            <div className="popup-content">
                <div className="popup-header">{item.styleInfo.description}</div>
                <div className="popup-suggestion">
                    <span className="original">{item.originalText}</span>
                    <span className="arrow">→</span>
                    <span className="formatted">{item.suggestionText}</span>
                </div>
                <div className="popup-actions">
                    <button className="popup-btn accept" onClick={onAccept}>Accept</button>
                    <button className="popup-btn reject" onClick={onReject}>Ignore</button>
                </div>
            </div>
        </div>
    );
};

export default AutoSuggestionPopup;
